'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Skeleton", {
    enumerable: true,
    get: function() {
        return Skeleton;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useSkeleton = require("./useSkeleton");
const _renderSkeleton = require("./renderSkeleton");
const _useSkeletonStylesstyles = require("./useSkeletonStyles.styles");
const _useSkeletonContextValues = require("./useSkeletonContextValues");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Skeleton = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useSkeleton.useSkeleton_unstable)(props, ref);
    const contextValues = (0, _useSkeletonContextValues.useSkeletonContextValues)(state);
    (0, _useSkeletonStylesstyles.useSkeletonStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useSkeletonStyles_unstable')(state);
    return (0, _renderSkeleton.renderSkeleton_unstable)(state, contextValues);
});
Skeleton.displayName = 'Skeleton';
